export function isMobile(): boolean {
	return (
		!!navigator.platform &&
		(/Android|webOS|iPad|iPhone|iPod|BlackBerry|Windows Phone/.test(navigator.platform) ||
			(navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1))
	);
}
